<template>
    <div class="stepFour">
        <headers></headers>
        <div class="content">
            <steps :step-num="3"></steps>
            <div class="stepFour-content">
                <Icon type="md-checkmark-circle" />
                <p>激活成功，5秒后返回登录！<a @click="goLogin">登录</a></p>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import headers from '../../components/pc/header.vue'
    import steps from '../../components/pc/steps.vue'
    export default {
        name: "stepFour",
        components: {
            headers,
            steps
        },
        data() {
            return {

            }
        },
        created() {
            if(!this.userInfos.sessionId) {
                this.$router.push({path: '/stepOne',query: {service: this.$route.query.service}})
            } else {
                setTimeout(() => {
                    if(this.$route.query.service) {
                        location.href = 'https://authserver.nbt.edu.cn/authserver/login?service=' + this.$route.query.service
                    } else {
                        location.href = 'https://authserver.nbt.edu.cn/authserver/login'
                    }
                },5000)
            }
        },
        computed: {
            ...mapState({
                userInfos: state=>state.userInfo,
                cardIds: state=>state.cardId,
            })
        },
        methods: {
            goLogin() {
                if(this.$route.query.service) {
                    location.href = 'https://authserver.nbt.edu.cn/authserver/login?service=' + this.$route.query.service
                } else {
                    location.href = 'https://authserver.nbt.edu.cn/authserver/login'
                }
            }
        }
    }
</script>

<style scoped>
    .content{
        width: 800px;
        margin: 50px auto 0;
    }
    .stepFour-content{
        width: 360px;
        margin: 50px auto 0;
        text-align: center;
    }
    .stepFour-content i{
        font-size: 40px;
        color: #19be6b;
    }
    .stepFour-content p{
        margin-top: 30px;
    }
</style>



// WEBPACK FOOTER //
// stepFour.vue?bb2e49fe